import React, { useState } from "react";
import {
  Link,
  useNavigate,
} from "react-router-dom";
import { login, getCurrentUser } from "../services/authApi";

const SignInLayer = () => {
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    email: "",
    password: "",
  });
  const [error, setError] = useState("");
  const [needsVerification, setNeedsVerification] =
    useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleChange = (event) => {
    const { name, value } = event.target;

    setFormData((current) => ({
      ...current,
      [name]: value,
    }));

    if (error) {
      setError("");
    }

    if (needsVerification) {
      setNeedsVerification(false);
    }
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    if (isSubmitting) {
      return;
    }

    setError("");
    setNeedsVerification(false);
    setIsSubmitting(true);

    try {
      await login({
        email: formData.email.trim(),
        password: formData.password,
      });

      const session = await getCurrentUser();

      if (session?.user?.platformAdmin) {
        window.location.assign("/admin/");
        return;
      }

      navigate("/dashboard", {
        replace: true,
      });
    } catch (requestError) {
      if (requestError.code === "EMAIL_NOT_VERIFIED") {
        setNeedsVerification(true);
        setError(
          requestError.message ||
            "Verify your email before signing in."
        );
        return;
      }

      if (requestError.code === "INVALID_CREDENTIALS") {
        setError("Invalid email or password.");
        return;
      }

      if (requestError.code === "ACCOUNT_UNAVAILABLE") {
        setError(
          "This account is currently unavailable. Please contact support."
        );
        return;
      }

      setError(
        requestError.message ||
          "We could not sign you in. Please try again."
      );
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="simplif-auth-page">
      <header className="simplif-auth-header">
        <Link to="/sign-in" className="simplif-auth-logo">
          <img
            src="/assets/images/simplif/simplif-logo.png"
            alt="Simplif"
          />
        </Link>

        <div className="simplif-auth-header-actions">
          <Link to="/sign-in" className="simplif-auth-login-link">
            Login
          </Link>

          <Link to="/sign-up" className="simplif-auth-signup-button">
            SIGN UP
          </Link>
        </div>
      </header>

      <main className="simplif-auth-main">
        <div className="simplif-auth-card">
          <section className="simplif-auth-form-panel">
            <div className="simplif-auth-form-content">
              <h1>Welcome to Simplif</h1>

              <p className="simplif-auth-subtitle">
                Please login to your account
              </p>

              <form onSubmit={handleSubmit}>
                <div className="simplif-auth-field">
                  <label htmlFor="signin-email">Email</label>
                  <input
                    id="signin-email"
                    name="email"
                    type="email"
                    placeholder="Email"
                    autoComplete="email"
                    value={formData.email}
                    onChange={handleChange}
                    disabled={isSubmitting}
                    required
                  />
                </div>

                <div className="simplif-auth-field">
                  <label htmlFor="signin-password">Password</label>
                  <input
                    id="signin-password"
                    name="password"
                    type="password"
                    placeholder="Password"
                    autoComplete="current-password"
                    value={formData.password}
                    onChange={handleChange}
                    disabled={isSubmitting}
                    required
                  />
                </div>

                {error ? (
                  <p
                    className="simplif-auth-status-message"
                    role="alert"
                  >
                    {error}
                  </p>
                ) : null}

                {needsVerification ? (
                  <div className="simplif-auth-bottom-link">
                    <Link
                      to="/verify-email"
                      state={{
                        email: formData.email.trim(),
                      }}
                    >
                      Resend verification email
                    </Link>
                  </div>
                ) : null}

                <button
                  type="submit"
                  className="simplif-auth-primary-button"
                  disabled={isSubmitting}
                >
                  {isSubmitting
                    ? "Signing in..."
                    : "Sign In Now"}
                </button>

                <div className="simplif-auth-bottom-link">
                  <Link to="/forgot-password">
                    Forgot Password?
                  </Link>
                </div>
              </form>
            </div>
          </section>

          <section className="simplif-auth-side-panel">
            <div className="simplif-auth-pattern simplif-auth-pattern-top" />

            <div className="simplif-auth-side-content">
              <h2>Don&apos;t have an Account yet?</h2>

              <p>
                Sign up for a brand or influencers account today,
                completely Free!
              </p>

              <Link
                to="/sign-up"
                className="simplif-auth-secondary-button"
              >
                Sign Up
              </Link>
            </div>

            <div className="simplif-auth-pattern simplif-auth-pattern-bottom" />
          </section>
        </div>
      </main>
    </div>
  );
};

export default SignInLayer;

